// This file is auto-generated by @hey-api/openapi-ts

export const PaymentTypeEnum = {
    CASH: 'CASH',
    BANK_CARD: 'BANK_CARD',
    ELECTRONIC_WALLET: 'ELECTRONIC_WALLET',
    INVOICE: 'INVOICE',
    GOOGLE_PAY: 'GOOGLE_PAY',
    APPLE_PAY: 'APPLE_PAY'
} as const;

export type PaymentTypeEnum = typeof PaymentTypeEnum[keyof typeof PaymentTypeEnum];
